import script from "./PoolBalances.vue?vue&type=script&setup=true&lang=ts"
export * from "./PoolBalances.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__